// src/helpers/student_training_history_helper.js
import axios from "axios";
import { post, get, del } from "./api_helper";
import * as url from "./url_helper";

// ============================
// GET HISTORIES WITH FILTERS (PAGINATED)
// ============================
export const getHistoriesWithFilters = async (params) => {
    console.log("📤 GET_HISTORIES_WITH_FILTERS:", url.GET_HISTORIES_WITH_FILTERS);
    console.log("📤 Params:", params);
    
    try {
        // Use the post function from api_helper
        const response = await post(url.GET_HISTORIES_WITH_FILTERS, null, { params });
        console.log("📥 Response:", response);
        return response;
    } catch (error) {
        console.error("❌ Error in getHistoriesWithFilters:", error);
        throw error;
    }
};

// ============================
// GET ALL HISTORIES (WITHOUT PAGINATION)
// ============================
export const getAllHistoriesWithFilters = async (params) => {
    console.log("📤 GET_ALL_HISTORIES_WITH_FILTERS:", url.GET_ALL_HISTORIES_WITH_FILTERS);
    console.log("📤 Params:", params);
    
    try {
        const response = await post(url.GET_ALL_HISTORIES_WITH_FILTERS, null, { params });
        console.log("📥 Response:", response);
        return response;
    } catch (error) {
        console.error("❌ Error in getAllHistoriesWithFilters:", error);
        throw error;
    }
};

// ============================
// GET FILTER VALUES
// ============================
export const getFilterValues = async (organizationId) => {
    console.log("📤 GET_FILTER_VALUES:", url.GET_FILTER_VALUES);
    console.log("📤 Organization ID:", organizationId);
    
    try {
        const response = await get(url.GET_FILTER_VALUES, { 
            params: { organizationId: organizationId || 1 } 
        });
        console.log("📥 Filter values response:", response);
        return response;
    } catch (error) {
        console.error("❌ Error in getFilterValues:", error);
        throw error;
    }
};

// ============================
// GET AUTO GENERATION STATUS
// ============================
export const getAutoGenerationStatus = async () => {
    try {
        const response = await get(url.AUTO_GENERATE_STATUS);
        return response;
    } catch (error) {
        console.error("❌ Error in getAutoGenerationStatus:", error);
        return {
            running: false,
            totalBatchesProcessed: 0,
            totalStudentsProcessed: 0,
            progressPercentage: 0,
            errors: []
        };
    }
};

// ============================
// GENERATE HISTORY FOR BATCH
// ============================
export const generateBatchHistory = async (batchId) => {
    try {
        const response = await post(`${url.GENERATE_BATCH_HISTORY}${batchId}`);
        return response;
    } catch (error) {
        console.error("❌ Error in generateBatchHistory:", error);
        throw error;
    }
};

// ============================
// DELETE HISTORY
// ============================
export const deleteHistory = async (id) => {
    try {
        const response = await del(`${url.DELETE_HISTORY}${id}`);
        return response;
    } catch (error) {
        console.error("❌ Error in deleteHistory:", error);
        throw error;
    }
};

// ============================
// DELETE ALL HISTORIES FOR STUDENT
// ============================
export const deleteStudentHistory = async (studentId) => {
    try {
        const response = await del(`${url.DELETE_STUDENT_HISTORY}${studentId}/all`);
        return response;
    } catch (error) {
        console.error("❌ Error in deleteStudentHistory:", error);
        throw error;
    }
};

// ============================
// EXPORT TO EXCEL
// ============================
export const exportHistoryExcel = async (params) => {
    try {
        const axiosInstance = (await import("./api_helper")).axiosApi;
        const response = await axiosInstance({
            method: 'post',
            url: url.EXPORT_HISTORY_EXCEL,
            params: params,
            responseType: 'blob',
            timeout: 30000
        });
        return response;
    } catch (error) {
        console.error("❌ Error in exportHistoryExcel:", error);
        throw error;
    }
};

// ============================
// ADVANCED SEARCH
// ============================
export const advancedSearch = async (params) => {
    try {
        const response = await post(url.ADVANCED_SEARCH, null, { params });
        return response;
    } catch (error) {
        console.error("❌ Error in advancedSearch:", error);
        throw error;
    }
};

// ============================
// SEARCH BY KEYWORD
// ============================
export const searchByKeyword = async (organizationId, keyword, page = 0, size = 10) => {
    try {
        const response = await get(url.SEARCH_BY_KEYWORD, {
            params: { organizationId, keyword, page, size }
        });
        return response;
    } catch (error) {
        console.error("❌ Error in searchByKeyword:", error);
        throw error;
    }
};

// ============================
// START AUTO GENERATION
// ============================
export const startAutoGeneration = async (organizationId) => {
    try {
        const response = await post(`${url.AUTO_GENERATE_START}${organizationId}`);
        return response;
    } catch (error) {
        console.error("❌ Error in startAutoGeneration:", error);
        throw error;
    }
};

// ============================
// STOP AUTO GENERATION
// ============================
export const stopAutoGeneration = async () => {
    try {
        const response = await post(url.AUTO_GENERATE_STOP);
        return response;
    } catch (error) {
        console.error("❌ Error in stopAutoGeneration:", error);
        throw error;
    }
};